/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Ai_Actions_DescInputs */

const en_settings_ai_actions_desc = /** @type {(inputs: Settings_Ai_Actions_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each resume, cover letter, or interview prep uses 1 action.`)
};

const de_settings_ai_actions_desc = /** @type {(inputs: Settings_Ai_Actions_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeder Lebenslauf, jedes Anschreiben oder jede Vorstellungsgespräch-Vorbereitung verbraucht 1 Aktion.`)
};

const fr_settings_ai_actions_desc = /** @type {(inputs: Settings_Ai_Actions_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chaque CV, lettre de motivation ou préparation d'entretien utilise 1 action.`)
};

const es_settings_ai_actions_desc = /** @type {(inputs: Settings_Ai_Actions_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada currículum, carta de presentación o preparación de entrevista utiliza 1 acción.`)
};

const it_settings_ai_actions_desc = /** @type {(inputs: Settings_Ai_Actions_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ogni curriculum, lettera di presentazione o preparazione colloquio utilizza 1 azione.`)
};

const nl_settings_ai_actions_desc = /** @type {(inputs: Settings_Ai_Actions_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elk CV, motief of sollicitatievoorbereiding gebruikt 1 actie.`)
};

const pl_settings_ai_actions_desc = /** @type {(inputs: Settings_Ai_Actions_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Każdy życiorys, list motywacyjny lub przygotowanie do rozmowy kwalifikacyjnej zużywa 1 akty.`)
};

const fi_settings_ai_actions_desc = /** @type {(inputs: Settings_Ai_Actions_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jokainen elämäkerta, kansilehti tai haastattelun valmistelu käyttää 1 toimintaa.`)
};

const da_settings_ai_actions_desc = /** @type {(inputs: Settings_Ai_Actions_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hver CV, ansøgningsbrev eller interviewforberedelse bruger 1 handling.`)
};

const sv_settings_ai_actions_desc = /** @type {(inputs: Settings_Ai_Actions_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Varje CV, ansökningsbrev eller intervju förberedelse använder 1 åtgärd.`)
};

/**
* | output |
* | --- |
* | "Each resume, cover letter, or interview prep uses 1 action." |
*
* @param {Settings_Ai_Actions_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const settings_ai_actions_desc = /** @type {((inputs?: Settings_Ai_Actions_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Ai_Actions_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_ai_actions_desc(inputs)
	if (locale === "fr") return fr_settings_ai_actions_desc(inputs)
	if (locale === "es") return es_settings_ai_actions_desc(inputs)
	if (locale === "it") return it_settings_ai_actions_desc(inputs)
	if (locale === "nl") return nl_settings_ai_actions_desc(inputs)
	if (locale === "pl") return pl_settings_ai_actions_desc(inputs)
	if (locale === "fi") return fi_settings_ai_actions_desc(inputs)
	if (locale === "da") return da_settings_ai_actions_desc(inputs)
	if (locale === "sv") return sv_settings_ai_actions_desc(inputs)
	return en_settings_ai_actions_desc(inputs)
});